module.exports = __webpack_public_path__ + "img/arrow-sidebar.65dbe365.svg";